import React from "react";
import "./Megaheader.css";

import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import LoginSignupModal from "../LoginSignupModal/LoginSignupModal";
import LazyLoad from "react-lazy-load";

let headerLogo = "https://rr-media-files.s3.ap-south-1.amazonaws.com/HomeSlideImages/assets/Images/RRPL.jpeg";
let headerHam = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/headerHam.png";
let crossClose = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/crossClose.png";
let rightArrow = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/Group351.png";
let backarrow = "https://d2s80gmgq3vhu4.cloudfront.net/HomeSlideImages/assets/Images/backarrow.png";

function Megaheader() {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [isVisible, setIsVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [sidePanelRight, setSidePanelRight] = useState({ width: "0px" });
  const [sidePanelRightDesc, setSidePanelRightDesc] = useState({
    width: "0px",
  });
  useEffect(() => {
    function handleScroll() {
      const currentScrollPos = window.pageYOffset;
      setIsVisible(prevScrollPos > currentScrollPos || currentScrollPos <= 0);
      setPrevScrollPos(currentScrollPos);
    }

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);
  const [user, setUser] = useState([]);
  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("userRR")));
  }, []);
  const toggleRightPanel = () => {
    if (sidePanelRight.width == "0px") {
      setSidePanelRight({ width: "472px" });
    } else {
      setSidePanelRight({ width: "0px" });
    }
  };
  const toggleRightPanelDesc = () => {
    if (sidePanelRightDesc.width == "0px") {
      setSidePanelRightDesc({ width: "472px" });
    } else {
      setSidePanelRightDesc({ width: "0px" });
    }
  };

  const openModel = () => {
    setSidePanelRight({ width: "0px" });
    setSidePanelRightDesc({ width: "0px" });
    setModalShow(true);
  };

  const [mainDiv, setMainDiv] = useState(true);
  const [service, setService] = useState(false);
  const [insights, setInsights] = useState(false);
  const [properties, setProperties] = useState(false);

  const [searchIcon, setSearchIcon] = useState(false);

  const [aboutUs, setAboutUs] = useState(false);

  const ClickService = () => {
    setService(true);
    setMainDiv(false);
  };
  const Clickinsights = () => {
    setInsights(true);
    setMainDiv(false);
  };
  const ClickProperties = () => {
    setProperties(true);
    setMainDiv(false);
  };
  const ClickSearchIcon = () => {
    setInsights(true);
    setMainDiv(false);
  };
  const ClickaboutUs = () => {
    setAboutUs(true);
    setMainDiv(false);
  };

  const backButton = () => {
    setMainDiv(true);
    setService(false);
    setInsights(false);
    setProperties(false);

    setAboutUs(false);
  };

  // Mobile panel ke andar Link click hone par panel band ho jaye
  const closePanel = () => {
    setSidePanelRight({ width: "0px" });
    backButton();
  };

  const [searchIconImage, setSearchIconImage] = React.useState(false);

  function handelSearchChange() {
    setSearchIconImage(true);
  }

  // Makes non-native clickable elements (div/p/img used as buttons)
  // keyboard-operable and correctly exposed to the accessibility tree.
  const activateOnKey = (handler) => (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handler();
    }
  };

  return (
    <div>
      <LoginSignupModal show={modalShow} onHide={() => setModalShow(false)} />

      <div style={sidePanelRight} className="sidepanel page-noice-bg">
        <div className="right-panel-container desktoppanel">

          <div className="r-p-links-continaer">
            <Link className="r-p-link" to="/form" onClick={closePanel}>
              List Your Requirement
            </Link>
            <Link className="r-p-link" to="/properties" onClick={closePanel}>
              Find Properties
            </Link>{" "}
            <Link className="r-p-link" to="/career" onClick={closePanel}>
              Careers
            </Link>
            <Link className="r-p-link" to="/contactus" onClick={closePanel}>
              Contact us
            </Link>
          </div>
        </div>

        <div className="right-panel-container mobilepanel">
          {service && (
            <div className="navlinkdiv mobilenav-link px-2 mobileDiv">
              <LazyLoad>
                <p
                  onClick={backButton}
                  role="button"
                  tabIndex={0}
                  onKeyDown={activateOnKey(backButton)}
                >
                  {" "}
                  <img src={backarrow} alt="" /> Go back
                </p>
              </LazyLoad>

              <div className="tp-l-container mt-5">
                <h6 className="tp-l-heading large-heading fs-1 my-3 ">
                  Our Services
                </h6>
                <p className="small-text theme-grey-text">
                 Comprehensive commercial real estate solutions designed to help businesses lease, invest and grow across India.

                </p>
                <Link
                  to="/our-clients"
                  className="small-text theme-voilet-text"
                ></Link>
              </div>
              <div className="tp-r-container">
                <div className="tp-r-links-contianer">
                  <Link to="/corporate_leasing" className="link-container" onClick={closePanel}>
                    Corporate Leasing
                  </Link>
                  <Link to="/retail_services" className="link-container" onClick={closePanel}>
                    Retail Services
                  </Link>
                  {/* <a href="/warehouse_services" className="link-container">
                    Warehouse Services
                  </a> */}
                  <Link to="/investment_advisory" className="link-container" onClick={closePanel}>
                    Investment Advisory
                  </Link>
                  <Link to="/interior_management" className="link-container" onClick={closePanel}>
                    Interior Management
                  </Link>
                  <Link to="/properties" className="link-container" onClick={closePanel}>
                    Find Properties
                  </Link>
                  <Link to="/form" className="link-container" onClick={closePanel}>
                    List your Requirement
                  </Link>
                </div>
              </div>
            </div>
          )}
          {insights && (
            <div className="navlinkdiv mobilenav-link px-2  mobileDiv">
              <LazyLoad>
                <p
                  onClick={backButton}
                  role="button"
                  tabIndex={0}
                  onKeyDown={activateOnKey(backButton)}
                >
                  {" "}
                  <img src={backarrow} alt="" /> Go back
                </p>
              </LazyLoad>

              <div className="tp-l-container mt-5">
                <h6 className="tp-l-heading large-heading fs-1 my-3 ">
                  Our Insights
                </h6>
                <p className="small-text theme-grey-text">
                  Explore market intelligence, success stories and industry perspectives from one of India's leading commercial real estate consultants.

                </p>
                <Link
                  to="/our-clients"
                  className="small-text theme-voilet-text"
                ></Link>
              </div>
              <div className="tp-r-container">
                <div className="tp-r-links-contianer">
                  <Link className="link-container" to="/casestudy" onClick={closePanel}>
                    Case Studies
                  </Link>
                  <Link className="link-container" to="/media" onClick={closePanel}>
                    Media Coverage
                  </Link>
                  <Link className="link-container" to="/our-clients" onClick={closePanel}>
                    Our Clients
                  </Link>

                  <Link className="link-container" to="/market_trends" onClick={closePanel}>
                    Market Trends
                  </Link>
                </div>
              </div>
            </div>
          )}
          {/* {properties && (
            <div className="navlinkdiv mobilenav-link px-2  mobileDiv">
            <LazyLoad>
            <p onClick={backButton}>
                {" "}
                <img src={backarrow} /> Go back
              </p>
            </LazyLoad>
            
              <div className="tp-l-container mt-5">
                <h6 className="tp-l-heading large-heading fs-1 my-3 ">
                  Our Insights
                </h6>
                <p className="small-text theme-grey-text">
                  We help businesses small and big, to find, lease and occupy
                  properties for the different needs that they have. We are
                  Realistic Realtors.
                </p>
                <a
                  href="/our-clients"
                  className="small-text theme-voilet-text"
                ></a>
              </div>
              <div className="tp-r-container">
                <div className="tp-r-links-contianer">
                  <a className="link-container" href="/casestudy">
                    Case Studies
                  </a>
                  <a className="link-container" href="/media">
                    Media Coverage
                  </a>
                  <a className="link-container" href="/our-clients">
                    Our Clients
                  </a>

                  <a className="link-container" href="/market_trends">
                    Market Trends
                  </a>
                </div>
              </div>
            </div>
          )} */}
          {aboutUs && (
            <div className="navlinkdiv mobilenav-link px-2  mobileDiv">
              <LazyLoad>
                <p
                  onClick={backButton}
                  role="button"
                  tabIndex={0}
                  onKeyDown={activateOnKey(backButton)}
                >

                  <img src={backarrow} alt="" /> Go back
                </p>
              </LazyLoad>

              <div className="tp-l-container mt-5">
                <h6 className="tp-l-heading large-heading fs-1 my-3 ">
                  About Us
                </h6>
                <p className="small-text theme-grey-text">
                  We help businesses small and big, to find, lease and occupy
                  properties for the different needs that they have. We are
                  Realistic Realtors.
                </p>
                <Link
                  to="/our-clients"
                  className="small-text theme-voilet-text"
                ></Link>
              </div>
              <div className="tp-r-container">
                <div className="tp-r-links-contianer">
                  <Link to="/our-philosophy" className="link-container" onClick={closePanel}>
                    Our Philosophy
                  </Link>
                  <Link to="/team@rr" className="link-container" onClick={closePanel}>
                    Our Team
                  </Link>

                  <Link to="/career" className="link-container" onClick={closePanel}>
                    Careers
                  </Link>
                  <Link to="/csr" className="link-container" onClick={closePanel}>
                    CSR
                  </Link>
                  <Link to="/awards" className="link-container" onClick={closePanel}>
                    Awards & Affiliations
                  </Link>
                </div>
              </div>
            </div>
          )}
          {mainDiv && (
            <>
              <div className="navlinkdiv mobilenav-link">
                <nav>
                  <ul className="ull">
                    <li className="header-nav">
                      <LazyLoad>
                        <div
                          onClick={ClickService}
                          role="button"
                          tabIndex={0}
                          aria-label="Open Services menu"
                          onKeyDown={activateOnKey(ClickService)}
                        >
                          <a className="header-link">Our Services</a>
                          <img
                            className="right-arrow"
                            alt="right-arrow"
                            src={rightArrow}
                          />
                        </div>
                      </LazyLoad>


                    </li>
                    <li className="header-nav">
                      <LazyLoad>
                        <Link to="/properties" onClick={closePanel}>
                          <p className="header-link">
                            Properties

                          </p>
                        </Link>
                      </LazyLoad>


                    </li>
                    <li className="header-nav">
                      <LazyLoad>
                        <div
                          onClick={Clickinsights}
                          role="button"
                          tabIndex={0}
                          aria-label="Open Insights menu"
                          onKeyDown={activateOnKey(Clickinsights)}
                        >
                          <a className="header-link">Insights</a>
                          <img
                            className="right-arrow"
                            alt="right-arrow"
                            src={rightArrow}
                          />
                        </div>
                      </LazyLoad>

                    </li>
                    <li className="header-nav">
                      <LazyLoad>
                        <Link to="/blogs" onClick={closePanel}>
                          <p className="header-link">
                            Blogs

                          </p>
                        </Link>
                      </LazyLoad>


                    </li>
                    <li className="header-nav">
                      <LazyLoad>
                        <div
                          onClick={ClickaboutUs}
                          role="button"
                          tabIndex={0}
                          aria-label="Open About Us menu"
                          onKeyDown={activateOnKey(ClickaboutUs)}
                        >
                          <a className="header-link">About Us</a>
                          <img
                            className="right-arrow"
                            alt="right-arrow"
                            src={rightArrow}
                          />
                        </div>
                      </LazyLoad>

                    </li>
                  </ul>
                </nav>
              </div>

              <div className="r-p-links-continaer">
                <Link className="r-p-link" to="/form" onClick={closePanel}>
                  List Your Requirement
                </Link>
                <Link className="r-p-link" to="/properties" onClick={closePanel}>
                  Find Properties
                </Link>{" "}
                <Link className="r-p-link" to="/career" onClick={closePanel}>
                  Careers
                </Link>
                <Link className="r-p-link" to="/contactus" onClick={closePanel}>
                  Contact us
                </Link>
              </div>
            </>
          )}
        </div>
      </div>

      <header>
        <div
          className="containernav desktopnav "
          style={{
            position: "fixed",
            transition: "visibility 0.3s ease-in-out, opacity 0.3s ease-in-out",
            visibility: isVisible ? "visible" : "hidden",
            opacity: isVisible ? 1 : 0,
          }}
        >
          <div className="navlinkdiv  ">
            <nav>
              <ul className="ull">
                <li>
                  <span className="header-link">
                    Services
                  </span>
                  <div className=" megamenuservice toppanel page-noice-bg">
                    <div className="tp-contianer">
                      <div className="tp-l-container">
                        <h2 className="tp-l-heading large-heading">
                          Our Services
                        </h2>
                        <p className="small-text theme-grey-text">
                         Comprehensive commercial real estate solutions designed to help businesses lease, invest and grow across India.

                        </p>
                        <Link
                          to="/our-clients"
                          className="small-text theme-voilet-text"
                        ></Link>
                      </div>
                      <div className="tp-r-container">
                        <div className="tp-r-links-contianer">
                          <Link
                            to="/corporate_leasing"
                            className="link-container"
                          >
                            Corporate Leasing
                          </Link>
                          <Link to="/retail_services" className="link-container">
                            Retail Services
                          </Link>
                          {/* <a
                            href="/warehouse_services"
                            className="link-container"
                          >
                            Warehouse Services
                          </a> */}
                          <Link
                            to="/investment_advisory"
                            className="link-container"
                          >
                            Investment Advisory
                          </Link>
                          <Link
                            to="/interior_management"
                            className="link-container"
                          >
                            Interior Management
                          </Link>
                        </div>
                        <div className="tp-r-links-contianer">
                          {/* <a
                            href="/Propertiesforsale"
                            className="link-container"
                          >
                            Properties for sale
                          </a>
                          <a
                            href="/Propertiesforlease"
                            className="link-container"
                          >
                            Properties for lease
                          </a> */}
                          <Link to="/properties" className="link-container">
                            Find Properties
                          </Link>
                          <Link to="/form" className="link-container">
                            List your Requirement
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                  <Link to="/properties" className="header-link">
                    Properties
                  </Link>
                </li>
                <li>
                  <Link to="/Insights" className="header-link">
                    Insights
                  </Link>
                  <div className=" megamenuinsights toppanel page-noice-bg">
                    <div className="tp-contianer">
                      <div className="tp-l-container">
                        <h1 className="tp-l-heading large-heading ">
                          Insights
                        </h1>
                        <p className="small-text theme-grey-text">
                          Explore market intelligence, success stories and industry perspectives from one of India's leading commercial real estate consultants.

                        </p>
                        <Link
                          to="/our-clients"
                          className="small-text theme-voilet-text"
                        ></Link>
                      </div>
                      <div className="tp-r-container">
                        <div className="tp-r-links-contianer">
                          <Link className="link-container" to="/casestudy">
                            Case Studies
                          </Link>
                          <Link className="link-container" to="/media">
                            Media Coverage
                          </Link>
                          <Link className="link-container" to="/our-clients">
                            Our Clients
                          </Link>

                          <Link className="link-container" to="/market_trends">
                            Market Trends
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
                <li>
                <Link to="/blogs" className="header-link">
                    Blogs
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
          <div className="logo">
            <Link to="/">
              <img
                className="mv-header-logo-image"
                alt="header-logo"

                src={headerLogo}
              />
            </Link>{" "}
          </div>

          <div className="lastnavdiv d-flex align-items-center justify-content-center">
            <nav>
              <ul className="ull">
                <li>
                  <Link
                    to="/aboutus"
                    className="header-link d-flex justify-content-center mt-1"
                  >
                    About Us
                  </Link>
                  <div className=" megamenuabouts toppanel page-noice-bg">
                    <div className="tp-contianer">
                      <div className="tp-l-container">
                        <h2 className="tp-l-heading large-heading ">
                          {" "}
                          About us
                        </h2>
                        <p className="small-text theme-grey-text">
                          We help businesses small and big, to find, lease and
                          occupy properties for the different needs that they
                          have. We are Realistic Realtors.
                        </p>
                        <Link
                          to="/our-clients"
                          className="small-text theme-voilet-text"
                        ></Link>
                      </div>
                      <div className="tp-r-container">
                        <div className="tp-r-links-contianer">
                          <Link to="/our-philosophy" className="link-container">
                            Our Philosophy
                          </Link>
                          <Link to="/team@rr" className="link-container">
                            Our Team
                          </Link>
                          {/* <a href="/aboutus" className="link-container">
                            Vision & Mission
                          </a> */}
                          <Link to="/career" className="link-container">
                            Careers
                          </Link>
                          <Link to="/csr" className="link-container">
                            CSR
                          </Link>
                          <Link to="/awards" className="link-container">
                            Awards & Affiliations
                          </Link>
                          {/* <a className="link-container" href="/our-clients">
                            Our Clients
                          </a> */}
                        </div>
                        <div className="tp-r-links-contianer">
                          {/* <a href="/csr" className="link-container">
                            CSR
                          </a>
                          <a href="/clients" className="link-container">
                            Clients
                          </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </li>



                <div className="flex flex-col justify-center">
                  {sidePanelRight.width === "0px" ? (
                    <img
                      className="img-fluid cursor-pointer"
                      onClick={() => toggleRightPanel()}
                      role="button"
                      tabIndex={0}
                      onKeyDown={activateOnKey(toggleRightPanel)}
                      alt="Open menu"
                      src={headerHam}
                    />
                  ) : (
                    <img
                      className="ham-icon cursor-pointer"
                      onClick={() => toggleRightPanel()}
                      role="button"
                      tabIndex={0}
                      onKeyDown={activateOnKey(toggleRightPanel)}
                      alt="Close menu"
                      src={crossClose}
                    />
                  )}
                  {/* <img className="ham-icon" alt="ham-icon" src={headerHam} /> */}
                </div>



              </ul>
            </nav>
          </div>
        </div>

        <div
          className="containernav mobilenav"
          style={{
            position: "fixed",
            transition: "visibility 0.3s ease-in-out, opacity 0.3s ease-in-out",
            visibility: isVisible ? "visible" : "hidden",
            opacity: isVisible ? 1 : 0,
          }}
        >
          <LazyLoad>
            <div className="navlinkdiv">
              <nav>
                <ul className="ull">
                  <li>
                    {" "}
                    {sidePanelRight.width == "0px" ? (
                      <img
                        className="ham-icon"
                        onClick={() => toggleRightPanel()}
                        role="button"
                        tabIndex={0}
                        onKeyDown={activateOnKey(toggleRightPanel)}
                        alt="Open menu"
                        src={headerHam}
                      />
                    ) : (
                      <img
                        className="ham-icon"
                        onClick={() => toggleRightPanel()}
                        role="button"
                        tabIndex={0}
                        onKeyDown={activateOnKey(toggleRightPanel)}
                        alt="Close menu"
                        src={crossClose}
                      />
                    )}

                  </li>
                </ul>
              </nav>
            </div>
          </LazyLoad>
          <LazyLoad>
            <div className="logo">
              <Link to="/">
                <img
                  className="mv-header-logo-image"
                  alt="header-logo"
                  src={headerLogo}
                />
              </Link>{" "}
            </div>
          </LazyLoad>


          <div className="lastnavdiv">
            <nav>
              <ul className="ull">

              </ul>
            </nav>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Megaheader;
